const type = 'SET_PAYMENT_COPIED';

const setPaymentCopied = (data) => ({
  data,
  type,
});

export { type };
export default setPaymentCopied;
